import * as types from '../constants/ActionTypes'

let defaultState = {
	'data': {},
	'isOpen': false,
	'name': null,
	'title': false,
	'state': ''
}

export default function app(state = defaultState, action) {
	switch (action.type) {
		case types.SET_MODAL:
			return {...state, ...action.payload};

			case types.RESET_MODAL:
				return defaultState;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/modal.js